import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: clamp(460px, 41.7vw, 560px);

  @media (max-width: 768px) {
    height: 520px;
  }

  @media (max-width: 480px) {
    height: 480px;
  }
`;

export const BackgroundImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
`;

export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.38);
  z-index: 1;
`;

export const HeroLogo = styled.img`
  height: 110px;
  width: auto;
  object-fit: contain;
  margin-bottom: 6px;

  @media (max-width: 768px) {
    height: 80px;
    margin-bottom: 4px;
  }

  @media (max-width: 480px) {
    height: 64px;
    margin-bottom: 4px;
  }
`;

export const NavButtons = styled.div`
  position: absolute;
  top: 24px;
  right: 32px;
  z-index: 10;
  display: flex;
  flex-direction: row;
  gap: 10px;

  @media (max-width: 480px) {
    top: 16px;
    right: 16px;
    gap: 8px;
  }
`;

export const NavSignInButton = styled.button`
  background-color: transparent;
  color: #ffffff;
  border: 1.5px solid rgba(255, 255, 255, 0.75);
  border-radius: 24px;
  padding: 8px 20px;
  font-family: 'Aileron', sans-serif;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.15);
  }

  @media (max-width: 480px) {
    padding: 7px 14px;
    font-size: 12px;
  }
`;

export const NavSignUpButton = styled.button`
  background-color: #000000;
  color: #ffffff;
  border: 1.5px solid #000000;
  border-radius: 24px;
  padding: 8px 20px;
  font-family: 'Aileron', sans-serif;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s ease;

  &:hover {
    background-color: #222222;
  }

  @media (max-width: 480px) {
    padding: 7px 14px;
    font-size: 12px;
  }
`;

export const IntroContainer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 20px;
`;

export const HeroHeading = styled.h1`
  font-family: 'Aileron', sans-serif;
  font-size: 72px;
  font-weight: 400;
  color: #ffffff;
  line-height: 1.05;
  margin: 0 0 16px 0;

  @media (max-width: 1024px) {
    font-size: 56px;
  }

  @media (max-width: 768px) {
    font-size: 42px;
    margin-bottom: 12px;
  }

  @media (max-width: 480px) {
    font-size: 34px;
  }
`;

export const HeroSubtitle = styled.p`
  font-family: 'Aileron', sans-serif;
  font-size: 17px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.88);
  margin: 0 0 32px 0;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 15px;
    margin-bottom: 24px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    margin-bottom: 20px;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  margin-bottom: 56px;

  @media (max-width: 768px) {
    margin-bottom: 40px;
  }

  @media (max-width: 480px) {
    margin-bottom: 32px;
  }
`;

export const PrimaryButton = styled.button`
  background-color: #000000;
  color: #ffffff;
  border: none;
  border-radius: 28px;
  width: 240px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Aileron', sans-serif;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background-color: #222222;
  }

  @media (max-width: 480px) {
    width: 216px;
    height: 50px;
    font-size: 15px;
  }
`;

export const SecondaryButton = styled.button`
  background-color: #e5d8cb;
  color: #000000;
  border: none;
  border-radius: 28px;
  width: 240px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: 'Aileron', sans-serif;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background-color: #d4c9bc;
  }

  @media (max-width: 480px) {
    width: 216px;
    height: 50px;
    font-size: 15px;
  }
`;

export const BunnyIcon = styled.img`
  height: 24px;
  width: 24px;
  object-fit: cover;
  border-radius: 50%;
  flex-shrink: 0;
`;

export const AppBadgesContainer = styled.div`
  position: absolute;
  bottom: 28px;
  right: 36px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  z-index: 2;

  @media (max-width: 768px) {
    bottom: 20px;
    right: 50%;
    transform: translateX(50%);
  }
`;

export const AppBadge = styled.img`
  height: 44px;
  width: auto;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.85;
  }

  @media (max-width: 480px) {
    height: 34px;
  }
`;
